import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getAnalytics, isSupported } from 'firebase/analytics'
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'
import { connectFunctionsEmulator } from 'firebase/functions'
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

// Import custom Firebase Functions configuration
import { createFunctions } from './firebase-functions-cors'
export const functions = createFunctions(app)

export const remoteConfig = getRemoteConfig(app)

// Initialize Firebase Cloud Messaging conditionally
export const messaging = isMessagingSupported().then(yes => yes ? getMessaging(app) : null)

// Initialize Analytics conditionally
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null)

// Configure Remote Config defaults
remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 0 : 3600000
remoteConfig.defaultConfig = {
  feature_guest_mode: true,
  feature_admin_ai: true,
  admin_ai_daily_quota: 50,
  min_locale_coverage: 0.8,
  notification_batch_size: 64,
}

// Connect to emulators in development
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectStorageEmulator(storage, 'localhost', 9199)
  connectFunctionsEmulator(functions, 'localhost', 5001)
  // connectRemoteConfigEmulator(remoteConfig, 'localhost', 9399) // Not available in current Firebase version
}

// Fetch and activate remote config
fetchAndActivate(remoteConfig).catch((err) => {
  console.warn('Failed to fetch remote config:', err)
})